export function createComponentSDKModel(factory) {
    return {
        factory,
    };
}
//# sourceMappingURL=createCorvidModel.js.map